import { render, staticRenderFns } from "./ContactNotes.vue?vue&type=template&id=e340eeb4"
import script from "./ContactNotes.vue?vue&type=script&lang=js"
export * from "./ContactNotes.vue?vue&type=script&lang=js"
import style0 from "./ContactNotes.vue?vue&type=style&index=0&id=e340eeb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports